import SigliveServiceV3 from 'Service/sigliveServiceV3';

const getReportHostSummary = async (queries) => {
  const { data } = await SigliveServiceV3({ method: 'GET', url: `/reporting/summary-host?${queries}` });

  return data?.data;
};

export default getReportHostSummary;
